// apps/web/src/pages/NotFound.tsx

import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button"; // <-- THIS IS THE MISSING IMPORT

const NotFound = () => {
  return (
    <section className="bg-background py-10 px-4">
      <div className="container mx-auto">
        <div className="flex justify-center">
          <div className="w-full max-w-lg text-center">
            
            <div className="four_zero_four_bg">
              <h1 className="text-center text-8xl font-bold text-transparent">404</h1>
            </div>

            <div className="-mt-14"> 
              <h3 className="text-4xl font-bold mb-4">
                Looks like you're lost
              </h3>
              
              <p className="text-muted-foreground mb-6">
                The page you are looking for is not available!
              </p>

              <Button asChild variant="premium" size="lg">
                  <Link to="/">Go to Home</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;